import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';

export default function StaffOnDuty({ data }) {
    const navigate = useNavigate();

    // Extract actual API data with zero-safe defaults
    const total = data?.total !== undefined && data?.total !== null ? Number(data.total) : 0;
    const required = data?.required !== undefined && data?.required !== null ? Number(data.required) : 0;
    
    // Dynamic shift calculation if not provided by backend
    const getCurrentShift = () => {
        const hour = new Date().getHours();
        if (hour >= 6 && hour < 14) return 'Morning Shift';
        if (hour >= 14 && hour < 22) return 'Evening Shift';
        return 'Night Shift';
    };
    const shift = data?.shift || getCurrentShift();

    // Actual checked in / out statistics
    const checkedIn = data?.checkedIn || (required > 0 ? `${total}/${required}` : `${total} In`);
    const checkedOut = data?.checkedOut || '0 Cleared';
    const dutyPercent = required > 0 ? Math.round((total / required) * 100) : (total > 0 ? 100 : 0);
    const statusLabel = required > 0
        ? (dutyPercent >= 100 ? 'Full Crew active' : `${dutyPercent}% active`)
        : (total > 0 ? `${total} active` : '0 active');

    return (
        <Card 
            onClick={() => navigate('/staff')}
            sx={{ 
                borderRadius: 3, 
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)', 
                border: '1px solid #f1f5f9',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }
            }}
        >
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                {/* Top Label & Shift Badge */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            fontWeight: 700, 
                            letterSpacing: '0.06em', 
                            color: '#94a3b8', 
                            textTransform: 'uppercase',
                            fontSize: '0.72rem'
                        }}
                    >
                        STAFF & SHIFTS
                    </Typography>
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 0.5, 
                            color: '#64748b', 
                            fontSize: '0.72rem', 
                            fontWeight: 500 
                        }}
                    >
                        <WbSunnyOutlinedIcon sx={{ fontSize: 13, color: '#94a3b8' }} />
                        <span>{shift}</span>
                    </Box>
                </Box>

                {/* Main Value & Full Crew active */}
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 2.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.1, fontSize: '1.85rem' }}>
                            {total}
                        </Typography>
                        <Typography variant="h6" sx={{ color: '#94a3b8', fontWeight: 600, fontSize: '1.25rem', ml: 0.5 }}>
                            / {required}
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.78rem' }}>
                        {statusLabel}
                    </Typography>
                </Box>

                {/* Bottom Row: In / Out / Duty % */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', pt: 0.5 }}>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            In:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.88rem' }}>
                            {checkedIn}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            Out:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.88rem' }}>
                            {checkedOut}
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#16a34a', fontSize: '0.82rem' }}>
                            {dutyPercent}% on duty
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}
